import { render, staticRenderFns } from "./ViewLaneClosureRequestBlockRestrictionListing.vue?vue&type=template&id=c2289a2e&"
import script from "./ViewLaneClosureRequestBlockRestrictionListing.vue?vue&type=script&lang=js&"
export * from "./ViewLaneClosureRequestBlockRestrictionListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports